import { Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';
import { TenantWordmark } from '@/components/feature/TenantWordmark';

interface AuthLayoutProps {
  children?: ReactNode;
  showLogo?: boolean;
}

export default function AuthLayout({ children, showLogo = true }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50 max-w-[375px] mx-auto relative flex flex-col">
      {showLogo && (
        <div className="flex items-center justify-center pt-10 pb-4">
          {/* The brand lockup already contains the wordmark, so it replaces the
              mark-plus-text pair outright. app-logo carries the dark-theme
              lift; see theme/mechanics.css. */}
          <TenantWordmark
            imgClassName="app-logo h-9 w-auto object-contain"
            textClassName="font-heading font-bold text-foreground-900 text-lg"
          />
        </div>
      )}
      <div className="flex-1 flex flex-col px-5 pb-6">
        {children ?? <Outlet />}
      </div>
    </div>
  );
}